import React from 'react';
import { Flex, Tooltip } from 'antd';
import { faCopy, faRefresh } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clipboardCopy from 'clipboard-copy';

import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExButton } from 'jf/components/DevExButton';
import { DevExLink } from 'jf/components/DevExLink';
import { DevExText } from 'jf/components/DevExText';
import { useTargetingClient } from 'jf/services/useTargetingClient';
import { getDevExEnv } from 'jf/utils/getDevExEnv';

const ReloadButton = () => (
  <DevExButton
    type="outline"
    icon={<FontAwesomeIcon icon={faRefresh} />}
    onClick={() => window.location.reload()}
  >
    Reload
  </DevExButton>
);

export const IntegrationSetup = () => {
  const isCustomerAdmin = window.dx.user?.isCustomerAdmin;
  const { msgProvider } = useTargetingClient();
  const devExEnv = getDevExEnv();
  const theme = useDevExTheme();

  if (isCustomerAdmin) {
    return (
      <>
        <DevExText lined>
          As an admin you can set up the {msgProvider} integration directly in{' '}
          <DevExLink href={`${devExEnv.appOrigin}/settings/plugins`} target="_blank">
            {'Jellyfish Settings > Integrations'}
          </DevExLink>
          .
        </DevExText>
        <DevExText lined>
          Once you're done, simply reload this page to start using {msgProvider}.
        </DevExText>
        <Flex justify="center">
          <Flex gap={theme.variable.spacing.sm}>
            <ReloadButton />
            <DevExButton
              href={`${devExEnv.appOrigin}/settings/plugins`}
              type="primary"
              target="_blank"
            >
              Go to settings
            </DevExButton>
          </Flex>
        </Flex>
      </>
    );
  }

  return (
    <>
      <DevExText lined>
        Contact your Jellyfish admin to set up your {msgProvider} integration in Jellyfish Settings
        {' > '}Integrations{' '}
        <Tooltip title="Copy link to clipboard">
          <FontAwesomeIcon
            icon={faCopy}
            onClick={() => {
              clipboardCopy(`${devExEnv.appOrigin}/settings/plugins`); // Optional: Notify the user
            }}
            color={theme.color.brand.active}
            style={{ cursor: 'pointer' }}
          />
        </Tooltip>
      </DevExText>
      <DevExText lined>
        Once they're done, simply reload this page to start using {msgProvider}
      </DevExText>
      <Flex justify="center">
        <ReloadButton />
      </Flex>
    </>
  );
};
